import { config } from '.';
import urljoin from 'url-join';
import parse from 'url-parse';
export function getEndpointFromUrl(url) {
    const parsedUrl = parse(url, true);
    const pathname = parsedUrl.pathname;
    return pathname.replace(getRouterBasename(), '');
}
export function getPathnameFromUrl(url) {
    const parsedUrl = parse(url, true);
    return parsedUrl.pathname;
}
export function absoluteUrl(endpoint, relativeTo = 'dist') {
    if (config(`paths.${relativeTo}`)) {
        return urljoin(config(`paths.${relativeTo}`), endpoint);
    }
    return '';
}
export function absolutePathname(endpoint, relativeTo = 'dist') {
    const url = absoluteUrl(endpoint, relativeTo);
    if (url) {
        const url = absoluteUrl(endpoint, relativeTo);
        let el = document.createElement('a');
        el.href = url;
        return el.pathname;
    }
    return '';
}
export function getRouterBasename() {
    if (config('paths.dist')) {
        let el = document.createElement('a');
        el.href = config('paths.dist');
        return el.pathname;
    }
    return '';
}
